import { useEffect } from 'react';

const DEFAULT_TITLE = "Eastwide Electrical Services | Electrician Servicing Victoria";
const DEFAULT_DESCRIPTION = "Eastwide Electrical Services is a registered electrical contractor servicing Victoria. LED digital screens, mains upgrades, underground wiring, and commercial maintenance. Call 0409 015 781 for a free quote.";

export function useDocumentMeta(title, description) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute('content', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
